import axios from "axios";
import { NotificationManager } from "../components/common/react-notifications";
import { servicePath, authParams } from "../config/defaultValues";
import { setLoader } from "../redux/actions";
import { logoutUser } from "../redux/auth/actions"


let token;
let config = {
  baseURL: servicePath,
  transformRequest: [
    (data, headers) => {
      var prefix = authParams.Header === "Authorization" ? 'Bearer ' : '';
      token = (localStorage.getItem('user_admin') ? JSON.parse(localStorage.getItem('user_admin')).token : undefined);
      if (!headers[authParams.Header])headers[authParams.Header] = prefix + token;
      return JSON.stringify(data);
    }
  ],
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": window.tenant.localeOptions? window.tenant.localeOptions.map(l => l = l.id)?.toString() : window.tenant.defaultLocale?? "es"
  }
};

const _axios = axios.create(config);

_axios.CancelToken = axios.CancelToken;

_axios.interceptors.request.use(
  request => {
    if (token !== undefined) {
      var exp = parseJwt(token).exp;
      var current_time = Date.now() / 1000;
      if (current_time > exp) {
        logoutUser();
        throw new axios.Cancel('Session expired! Please login again...');
      }
    }
    return request
  },
  error => {
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  (request) => {
    return request.data ? request.data : request
  },
  (error) => {
    setLoader(false);
    NotificationManager.error(error.response?.data?.Message || error.response?.data || `${error}`, 'Ooops', 5000, null, null, 'outline')
    if (error.response && error.response.status === 401) {
      logoutUser(); // no es reactivo solo limpia el localstorage
      window.location.hash = '#/user/login'
    }
    return Promise.reject(error)
  }
)

var parseJwt = function(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

export default _axios
